import classes from './ProcodocsNotifications.module.css'
import GoToDetailsTab from '../pages/custom/GoToDetailsTab'

export default function ProcodocsNotifications({data, item, caseData, slug}) {

    return <div>
        {/* item?.case.id */}
        <GoToDetailsTab tabNumber={19} workqSlug={slug} caseId={item?.patient.person_number}>
            <div className={classes.container}>
                <div className={`${classes.item} ${data?.ecm_unread_messages ? classes.active: ''}`}>
                    <i className='ti ti-message'></i>
                </div>
                <div className={`${classes.item} ${data?.ecm_unread_documents ? classes.active: ''}`}>
                    <i className='ti ti-file'></i>
                </div>
            </div>
        </GoToDetailsTab>
    </div>
}